import RoleForm from './role-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
import EditForm from '@/components/refinedev/pages/edit-form';

const RoleEdit = () => {
  return (
    <EditForm transformBeforeSave={RoleForm.transformBeforeSave}>
      <div className="max-w-xl mx-auto flex flex-col gap-y-4 ">
        <RoleForm />
        <SaveButton size="lg" className="self-end" />
      </div>
    </EditForm>
  );
};

export default RoleEdit;
